import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import Typography from '@material-ui/core/Typography';
//import ResolveRecord from '../supplierPOUpdate/UpdateRecord';
import ResolveReviewFile from './ResolveReviewFile';
import NewHeader from '../models/NewHeader';
import TitleObj from '../models/TitleObject';
import {
  quickViewAction,
  recordTimelineAction,
  recordResolutionAction,
} from '../../../containers/actions/cmo/shortFallsActions';
import {
  lineSource,
  resolutionSource,
  timelineSource,
} from '../../../containers/actions/cmo/shortFallsActions';
import axios from 'axios';
import { appUrl } from '../../../../../utils/config';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='down' ref={ref} {...props} />;
});

const Resolve = (props) => {
  const {
    open,
    POLineRecordDetails,
    row,
    status,
    handleClose,
    isRecordDelete,
    isUpdateRecord,
    saveRecord,
  } = props;

  const dispatch = useDispatch();

  // Get data from Redux
  const supplierPOData = useSelector(
    (state) => state.pcmp.cmo.shortFalls.quickView
  );
  const updateGRNData = useSelector(
    (state) => state.pcmp.cmo.shortFalls.updateGRNData
  );

  // Initialize state for ResolveReviewFile
  const [asnData, setAsnData] = useState({});
  const [batchData, setBatchData] = useState({});
  const [poDetails, setPoDetails] = useState(null);
  const [otherFiles, setOtherFiles] = useState([]);
  const [POBatchRecordDetails, setPOBatchRecordDetails] = useState({});
  const [otherInformationRemarks, setOtherInformation] = useState('');
  const [OtherInfoTempNumber, setOtherInfoTempNumber] = useState(0);
  const [loading, setLoading] = useState(true);
  const [dataLoaded, setDataLoaded] = useState(false);
  // const [coaName, setCoAName] = useState('CertificateOfAnalysis');

  // Fetch data on mount - only when dialog opens
  useEffect(() => {
    if (!open) {
      return;
    }

    if (!POLineRecordDetails || !row) {
      return;
    }

    const data = {
      supplierPurchaseOrderNumber:
        POLineRecordDetails.supplierPurchaseOrderNumber,
      materialCode: POLineRecordDetails.materialCode,
      schrockenSupplierPOBatchID: row.schrockenSupplierPOBatchID,
      collabType: localStorage.collabType,
      roleName: localStorage.roleName,
    };

    dispatch(quickViewAction(data));
    // dispatch(recordTimelineAction(data));
    // dispatch(recordResolutionAction(data));

    return () => {
      if (lineSource) lineSource.cancel('cancelling');
      if (resolutionSource) resolutionSource.cancel('cancelling');
      if (timelineSource) timelineSource.cancel('cancelled');
    };
  }, [open, POLineRecordDetails, row, dispatch]);

  // Update state when Redux data changes
  useEffect(() => {
    if (supplierPOData) {
      setPoDetails(supplierPOData);

      if (!supplierPOData.GRDetails) {
        setLoading(false);
        setDataLoaded(true);
        return;
      }

      const {
        POBatchRecordDetails,
        challanInformation,
        invoiceInformation,
        qualityAssuranceInfo,
        receivedQuantityInfo,
        asnDetails,
      } = supplierPOData.GRDetails;

      setPOBatchRecordDetails(POBatchRecordDetails || {});
      setOtherInformation(POBatchRecordDetails?.otherInformationRemarks || '');
      setOtherFiles(POBatchRecordDetails?.otherFiles || []);

      // Map ASN data
      if (asnDetails) {
        setAsnData({
          asnNumber: asnDetails.asnNumber || '',
          asnDocumentDate: asnDetails.asnLastModifiedDate || '',
          asnScheduleDeliveryDate: asnDetails.asnDeliveryDate || '',
          ewayBillNumber: challanInformation.ewayBillNumber || '',
          ewayBillDate: challanInformation?.ewayBillDate || '',
          boeNumber: asnDetails.asnBoENO || '',
          boeDate: asnDetails.asnBoEIDDate || null,
          lorryReceiptNumber: POBatchRecordDetails.lorryReceiptNumber || '',
          transporterName: POBatchRecordDetails.transporterName || '',
          invoiceNumber: invoiceInformation.invoiceNumber || '',
          invoiceDate: invoiceInformation.invoiceDate || '',
          challanNumber: challanInformation.challanNumber || '',
          challanDate: challanInformation.challanDate || '',
          vehicleNumberSupplier: asnDetails.vehicleNumberSupplier || '',
          vehicleNumberCMO: challanInformation.vehicleNumberCMO || '',
          coaDocumentID: asnDetails.coaDocumentID || '',
        });
      }

      // Map Batch data
      setBatchData({
        // analyticalReportNumber:
        //   qualityAssuranceInfo.analyticalReportNumber || '',
        batchNumberQA: qualityAssuranceInfo.batchNumberQA || '',
        numberMRN: POBatchRecordDetails.numberMRN || '',
        asnUOM: receivedQuantityInfo.unitOfMeasurementReceived || '',
        asnBatchQuantity: asnDetails.asnBatchQuantity || '',
        actualQuantityReceived:
          receivedQuantityInfo.actualQuantityReceived || '',
        materialReceivedDate: POBatchRecordDetails.materialReceivedDate || '',
        expirationDate: qualityAssuranceInfo.expirationDate || '',
        materialManufactureDate:
          qualityAssuranceInfo.materialManufactureDate || '',
      });

      // Mark as loaded after all data is set
      setLoading(false);
      setDataLoaded(true);

      // const Id = asnDetails.coaDocumentID;
      // if (Id) {
      //   axios
      //     .get(
      //       `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/getCOADetails/download/${Id}`
      //     )
      //     .then((res) => {
      //       if (res.data.status) {
      //         setCoAName(res.data.fileName);
      //       }
      //     })
      //     .catch((err) => {
      //       console.log(err);
      //     });
      // }
    }
  }, [supplierPOData]);

  const handleChange = (e, name) => {
    const { value } = e.target;
    if (name === 'otherInformationRemarks') {
      setPOBatchRecordDetails((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handlingFiles = (file, name) => {
    if (name === 'otherFiles') {
      setPOBatchRecordDetails((prev) => ({
        ...prev,
        otherFiles: [...(prev.otherFiles || []), file],
      }));
    }
  };

  const parentHandlingDeleteFile = (i, name) => {
    if (name === 'otherFiles') {
      if (
        window.confirm(
          'You are about to delete a file, would you like to proceed?'
        )
      ) {
        if (
          POBatchRecordDetails.otherFiles &&
          POBatchRecordDetails.otherFiles[i]?.grFileType === 'buffer'
        ) {
          let newFiles = POBatchRecordDetails.otherFiles.filter(
            (file) =>
              file.grFileName !== POBatchRecordDetails.otherFiles[i].grFileName
          );
          setPOBatchRecordDetails({
            ...POBatchRecordDetails,
            otherFiles: newFiles,
          });
        }
      }
    }
  };

  const handleTempNumber = (name) => {
    if (name === 'OtherInfoTempNumber') {
      setOtherInfoTempNumber(OtherInfoTempNumber + 1);
    }
  };

  if (!open) {
    return null;
  }

  if (loading || !dataLoaded) {
    return (
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <NewHeader
          handleClose={handleClose}
          title='Edit/Update Record Details'
          subtitle='Raw Material (RM) / Packaging Material (PM) Record'
          padding={true}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              padding: '2rem',
            }}
          >
            <Typography>Loading data...</Typography>
          </div>
        </NewHeader>
      </Dialog>
    );
  }

  if (!POLineRecordDetails || !row) {
    return null;
  }

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      {/* <ResolveRecord
        POLineRecordDetails={POLineRecordDetails}
        status={status}
        row={row}
        handleClose={handleClose}
        isRecordDelete={isRecordDelete}
        isUpdateRecord={isUpdateRecord}
        saveRecord={saveRecord}
      /> */}
      <NewHeader
        handleClose={handleClose}
        title='Edit/Update Record Details'
        subtitle='Raw Material (RM) / Packaging Material (PM) Record'
        padding={true}
      >
        <ResolveReviewFile
          GRData={row}
          POLineRecordDetails={POLineRecordDetails}
          status={status}
          row={row}
          handleClose={handleClose}
          isRecordDelete={isRecordDelete}
          isUpdateRecord={isUpdateRecord}
          saveRecord={saveRecord}
          onClose={handleClose}
          asnData={asnData}
          setAsnData={setAsnData}
          batchData={batchData}
          setBatchData={setBatchData}
          poDetails={poDetails}
          otherFiles={otherFiles}
          setOtherFiles={setOtherFiles}
          POBatchRecordDetails={POBatchRecordDetails}
          setPOBatchRecordDetails={setPOBatchRecordDetails}
          handleChange={handleChange}
          handlingFiles={handlingFiles}
          parentHandlingDeleteFile={parentHandlingDeleteFile}
          OtherInfoTempNumber={OtherInfoTempNumber}
          handleTempNumber={handleTempNumber}
          otherInformationRemarks={otherInformationRemarks}
          setOtherInformation={setOtherInformation}
          // coaName={coaName}
        />
      </NewHeader>
    </Dialog>
  );
};
export default Resolve;
